import { Badge } from 'antd'
import type { BadgeProps } from 'antd'
import type { CSSProperties } from 'react'

const BARE_INDICATOR_STYLE = {
  background: 'transparent',
  boxShadow: 'none',
  minWidth: 'auto',
  padding: 0,
  verticalAlign: 'middle'
} as const

export type CountBadgeProps = {
  count?: number
  size?: CSSProperties['fontSize']
  weight?: CSSProperties['fontWeight']
  color?: CSSProperties['color']
  indicatorStyle?: CSSProperties
} & Omit<
  BadgeProps,
  'count' | 'dot' | 'status' | 'text' | 'styles' | 'size' | 'color'
>

export const CountBadge = ({
  count,
  size,
  weight,
  color,
  indicatorStyle,
  ...props
}: CountBadgeProps) => (
  <Badge
    {...props}
    count={count}
    styles={{
      indicator: {
        ...BARE_INDICATOR_STYLE,
        fontSize: size,
        fontWeight: weight,
        color: color ?? 'inherit',
        ...indicatorStyle
      }
    }}
  />
)
